import React from "react";
import Rollbar from '../../utils/RollbarTracking'
import axios from 'axios'
import { toast } from 'react-toastify';

import {SettingsNav} from '../../components/SettingsNav'

export class SettingsXero extends React.Component {

  state = {
    settings: {},
    enabled: false
  }

  componentWillMount() {
    this.fetchSupplierData();
  }

  fetchSupplierData = async () => {
    axios.get('/user')
        .then(data => {
          var settings = JSON.parse(data[0].settings)
          this.setState({
            settings: settings,
            enabled: settings.integration.enabled && settings.integration.type === 'xero'
          });
        })
        .catch (err => {
          console.error(err)
          Rollbar.error(err)
          toast.error('Failed to fetch user data')
        })
  }

  updateSettings = async (del) => {
    let settings = this.state.settings
    if (del) {
      settings.integration = {}
    }
    let requestParams = {
      'settings': settings
    }
    axios.post('/user/update/settings', requestParams)
        .then(data => {
          toast.success("Xero Settings Saved!");
          this.fetchSupplierData()
        })
        .catch (err => {
          console.error(err); 
          Rollbar.error(err)
          toast.error("Error: Could not save settings!");
        })
  }

  getAuthUrl = async () => {
    axios.get('/xero/auth/url')
        .then(data => {
          window.location.href = data.url
        })
        .catch (err => {
          console.error(err)
          Rollbar.error(err)
          toast.error('Failed to fetch auth url')
        })
  }

  syncData = async () => {
    toast.warning('Syncing Data...please wait', {autoClose: false})
    axios.get('/xero/sync')
        .then(data => {
          toast.dismiss()
          this.fetchSupplierData()
        })
        .catch (err => {
          console.error(err);
          Rollbar.error(err)
          toast.dismiss()
          toast.error('Failed to sync data')
        })
  }

    render() {
        return (
            <div className="mar-bot-lg">
              <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-1 mb-3 border-bottom">
                <h1 className="h3">Settings</h1>
              </div>
              <div className="row">
                <div className="col-md-2 col-sm-12">
                  <SettingsNav/>
                </div>
                <div className="col-md-10 col-sm-12">
                  <div className="card">
                    <div className="card-header">
                      Xero Integration Settings
                    </div>
                    <div className="card-body">
                      <div className="form-group">
                        <label className="checkbox-heading-label">Xero Integration: 
                          {this.state.enabled ? 
                          <span className="badge badge-success ml-1">Active</span> : 
                          <span className="badge badge-danger ml-1">Inactive</span>}
                        </label>
                      </div>
                      {this.state.enabled ? 
                      <div className="form-group">
                        <label>Sync Status</label>
                        <button type="button" onClick={this.syncData} className="btn btn-warning btn-sm float-right">Sync Now</button>
                        <table className="table">
                          <thead>
                            <tr>
                              <th>Entity</th>
                              <th className="text-right">Last Sync</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>Products (Items)</td>
                              <td className="text-right text-success">{this.state.settings.integration.productsLastSync}</td>
                            </tr>
                            <tr>
                              <td>Customers (Contacts)</td>
                              <td className="text-right text-success">{this.state.settings.integration.customersLastSync}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>: null}
                      {!this.state.enabled ? 
                      <div>
                        <button type="button" onClick={this.getAuthUrl} className="btn btn-primary btn-block mar-bot">Link Xero</button>
                      </div> : 
                      <div>
                        <button type="button" onClick={()=>this.updateSettings(true)} className="btn btn-danger btn-block mar-bot">Disable Integration</button>
                      </div>}
                    </div>
                  </div>
                </div>
              </div>
            </div>
        );
    }
}
